import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { TableComponent } from '../table/table.component';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-player-profit',
  templateUrl: './player-profit.component.html',
  styleUrls: ['./player-profit.component.scss']
})
export class PlayerProfitComponent implements AfterViewInit {

  @ViewChild("history") history! : TableComponent;
  @Input() set setPlaterUUID(v){
    this.player_uuid = v
  };

  public is_loading = false;
  private player_uuid:string|null;
  public data: any = {};
  public player_ids: any = [];
  public active_player_ids: any = [];
  public summary: any = {};
  public sections:any = [];
  public setting: any = {};

  constructor(private http: HttpService) { }

  ngAfterViewInit(): void {
    this.init()
  }
  
  async init() {
    this.is_loading = true;
    const rtn = await this.http.post("/admin/player/get/summary/all",  {player_uuid: this.player_uuid, status: 1});
    this.data = rtn['player']
    this.player_ids = rtn['player_ids']
    this.active_player_ids = rtn['active_player_ids']
    this.summary = rtn['summary']

    this.sections = rtn['sections'];

    this.setting = rtn['setting'];
    this.is_loading = false;

  }
}
